import React from 'react';
import { AuditTrailView } from '../../../project/components/dashboard/auditTrail/AuditTrailView';

export const AdminAuditTrail: React.FC = () => (
  <AuditTrailView
    enableProjectFilter
    description="System-wide activity log across projects. Filter by project, module, event, actor, or date range."
  />
);
